import { useEffect } from 'react';
import { Header } from '../../../common/Header/Header.jsx';
import { TVProvidersCounterTable } from '../../../common/Tables/Tables.jsx';
import { TVProvidersCounterHeader } from '../../../../assets/helpers/tables.js';
import { LoadSpinner } from '../../../common/LoadSpinner/LoadSpinner.jsx';
import authService from '../../../../services/authService.js';
import { exportablesTypes } from '../../../../assets/helpers/options.js';
import {
  FilterDatePicker,
  SearchInput,
} from '../../../common/Forms/Input/Input.jsx';
import { useTvSectionStore } from '../../../../stores/tvSectionStore.js';
import './TvSection.scss';

export const TvSection = () => {
  const userRole = authService.getUserType();
  const {
    sinceDate,
    untilDate,
    name,
    data,
    setSinceDate,
    setUntilDate,
    setName,
    fetchServicesByOperatorTV,
  } = useTvSectionStore();

  useEffect(() => {
    fetchServicesByOperatorTV();
  }, [fetchServicesByOperatorTV, sinceDate, untilDate, name]);

  const handleSinceDateChange = (e) => setSinceDate(e);
  const handleUntilDateChange = (e) => setUntilDate(e);
  const handleSearchChange = (e) => setName(e?.target?.value);

  return (
    <>
      <LoadSpinner show={data.isLoading} />
      <Header />
      <div className="service-with-container container">
        <h1 className="title-component">
          Sección TV
        </h1>
        <div className="breadcrumb-container">
          <div className="exportables-buttons-container">
            <div style={{ marginTop: '36px', marginRight: '12px' }}>
              <SearchInput
                placeholder="Nombre"
                width="260px"
                value={name}
                onChange={handleSearchChange}
                searchAction={fetchServicesByOperatorTV}
              />
            </div>
            <FilterDatePicker
              bootstrap="col-8"
              label="Desde"
              type="date"
              name="sinceDate"
              placeholder=""
              onChange={handleSinceDateChange}
              value={sinceDate}
            />
            <FilterDatePicker
              bootstrap="col-4"
              label="Hasta"
              type="date"
              name="untilDate"
              placeholder=""
              onChange={handleUntilDateChange}
              value={untilDate}
            />
          </div>
          <span></span>
        </div>
        <div className="gray-line"></div>
        <div className="tv-section-content">
          <TVProvidersCounterTable
            header={TVProvidersCounterHeader}
            data={data}
            type={exportablesTypes.PAYMENT_AV}
            userRole={userRole}
          />
        </div>
      </div>
    </>
  );
};
